"use client";

// Lightweight cookie / tracking notice.
//
// Informational, implied-consent style (common for TW SMB sites): analytics and
// marketing tags load by default; this bar tells visitors and lets them
// acknowledge. The choice is remembered in localStorage so it shows once.
//
// To switch to strict opt-in (don't load Meta Pixel / Clarity until "接受"),
// gate those components on a `consent === 'accepted'` flag read from the same
// storage key — the key contract is intentionally simple for that upgrade.
import { useEffect, useState } from "react";

const STORAGE_KEY = "meowmi-cookie-consent";

// 2026-10:貼紙頁底部有「已選 N 張 / 結帳」條時,往上讓出它的高度
// (--checkout-bar-h 由 lib/checkoutChrome.js 寫入;沒有結帳條 = 0,維持貼底)。
// 結帳表單開著時整個框先藏起來(globals.css 的 data-checkout-open 規則)。
const BANNER_POSITION = { bottom: "var(--checkout-bar-h, 0px)" };

export default function ConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      // One-shot mount-time read from an external store (localStorage) — same
      // intentional pattern as CartProvider; can't run during SSR render.
      // eslint-disable-next-line react-hooks/set-state-in-effect
      if (!window.localStorage.getItem(STORAGE_KEY)) setVisible(true);
    } catch {
      /* storage blocked — don't nag, just stay hidden */
    }
  }, []);

  const accept = () => {
    try {
      window.localStorage.setItem(STORAGE_KEY, "accepted");
    } catch {
      /* ignore — UI still dismisses for this session */
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label="Cookie 使用說明"
      data-consent-banner=""
      className="fixed inset-x-0 bottom-0 z-[90] px-4 pb-[calc(12px+var(--safe-area-bottom,0px))] pt-3 animate-fade-in"
      style={BANNER_POSITION}
    >
      <div
        className="mx-auto flex max-w-3xl flex-col gap-3 rounded-2xl px-4 py-3.5 sm:flex-row sm:items-center sm:justify-between"
        style={{
          backgroundColor: "var(--color-cardBg)",
          border: "1px solid var(--color-cardBorder)",
          boxShadow: "0 6px 30px rgba(0,0,0,0.12)",
        }}
      >
        <p
          className="text-xs leading-relaxed sm:text-sm"
          style={{ color: "var(--color-textSecondary)" }}
        >
          我們使用 Cookie 與分析工具改善瀏覽體驗並了解作品的受歡迎程度。繼續使用即表示你同意。
        </p>
        <button
          type="button"
          onClick={accept}
          className="shrink-0 self-end rounded-full px-5 py-2 text-sm font-medium text-white transition-transform active:scale-95 sm:self-auto"
          style={{ backgroundColor: "var(--color-accent)" }}
        >
          接受
        </button>
      </div>
    </div>
  );
}
